import RequestAbstract from '../abstract';

export default class Providers extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-providers';
    }
}
